import { render, staticRenderFns } from "./ProductFavoritesTable.vue?vue&type=template&id=bbb068b8&scoped=true"
import script from "./ProductFavoritesTable.vue?vue&type=script&lang=js"
export * from "./ProductFavoritesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb068b8",
  null
  
)

export default component.exports